import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var CheckAccountVerificationStatusIA = function CheckAccountVerificationStatusIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.MyOrders.BUSINESS_PROFILE ? articlePage(articles.MyOrders.BUSINESS_PROFILE.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_PROVIDED_ALL_REQUIRED_INFO(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "01NZtH",
    defaultMessage: [{
      "type": 0,
      "value": "Geef ons ten minste 1 werkdag de tijd om je gegevens te controleren"
    }]
  });
};
var IF_YOU_PROVIDED_ALL_REQUIRED_INFO = function IF_YOU_PROVIDED_ALL_REQUIRED_INFO(strictLocalize) {
  return strictLocalize({
    id: "H4pphv",
    defaultMessage: [{
      "type": 0,
      "value": "Als je alle vereiste informatie hebt opgegeven in het accountverificatieformulier, ontvang je een e-mail zodra we deze hebben beoordeeld. We reageren meestal binnen 1 werkdag."
    }]
  });
};